import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { BehaviorSubject } from "rxjs";
import { CustomerService } from "./customer.service";

import { HistoryClient, WebRecentActivity } from "src/app/models";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class HistoryService
{
  private activitiesSubject: BehaviorSubject<WebRecentActivity[]> = new BehaviorSubject<WebRecentActivity[]>(null);
  recentActivities: Observable<WebRecentActivity[]> = this.activitiesSubject.asObservable();

  constructor(
    private historyClient: HistoryClient,
    private customerService: CustomerService,
    private authService: AuthService
  ) 
  {
    this.customerService.customerId.subscribe(customerId => 
    {

      if (customerId !== "" && this.authService.isLoggedIn())
      {
        this.getRecentActivities(customerId);
      }
    });
  }

  private getRecentActivities(branchCustId: string): void
  {
    this.historyClient.getRecentActivities(branchCustId)
      .subscribe(activities => this.activitiesSubject.next(activities));
  }
}
